import { useTranslation } from "react-i18next";
import { FilterProperty } from "./types";

export const TABLE_ITEMS = [
  { key: "ordernumber", property: FilterProperty.OrderNumber },
  { key: "sku", property: FilterProperty.Sku },
  { key: "product", property: FilterProperty.ProductName },
  { key: "location", property: FilterProperty.Location },
  { key: "category", property: FilterProperty.Category },
  { key: "condition", property: FilterProperty.Condition },
  { key: "warranty_till", property: FilterProperty.WarrantyTill },
  { key: "service_state", property: FilterProperty.ServiceState },
];

export function DpcTableHead() {
  const { t } = useTranslation();

  return (
    <thead>
      <tr>
        {TABLE_ITEMS.map((item) => (
          <th
            key={item.property}
            className="border-b-2 h-[60px] pl-5 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap"
          >
            {t(`table.${item.key}`)}
          </th>
        ))}
      </tr>
    </thead>
  );
}
